module.exports = __webpack_public_path__ + "img/logo-multicolour.f0754f5f.png";